<template>
  <div class="headerTop">
    <div class="left">
      <div>
        <div><img src="../../assets/imges/ling.png" alt="" />领劵中兴</div>
        |
        <div style="flex: 3">
          客户名称:{{ uname }}
          <span style="padding-left: 2rem">欢迎您:{{ User_Phone }}</span>
        </div>
        |
        <div>
          <router-link style="color: #fff" class="link" to="my"
            >会员中心</router-link
          >
        </div>
        |
        <div><img @click="exit" src="../../assets/imges/off.png" alt="" /></div>
      </div>
    </div>

    <div class="headerCenetr">
      <div class="HeaderLetf">
        <div style="margin-left: 3rem">
          <img src="../../assets/imges/JD963774380491.png" alt="" />
        </div>
        <div>
          <ul>
            <li>
              <img src="../../assets/imges/kefu.png" alt="" />
              <span>业务专员:</span> <i>彭易权</i>
            </li>
            <li>
              <img src="../../assets/imges/phone.png" alt="" />
              <span>联系电话:</span><i>0755-2308-0620</i>
            </li>
            <li>
              <img src="../../assets/imges/phone1.png" alt="" /><span
                >手机号码:</span
              ><i>18129846935</i>
            </li>

            <li>
              <img src="../../assets/imges/qq.png" alt="" /> <span>QQ:</span>
              <i
                ><a
                  href="http://wpa.qq.com/msgrd?v=3&amp;uin=574039568&amp;site=qq&amp;menu=yes"
                />574039568</i
              >
            </li>
          </ul>
        </div>
        <div style="border-left: 0.1rem solid #aaa">
          <ul>
            <li>
              <img src="../../assets/imges/kefu.png" alt="" />
              <span>业务专员:</span><i>陈泰先</i>
            </li>
            <li>
              <img src="../../assets/imges/phone.png" alt="" />
              <span>联系电话:</span><i>0755-23080620</i>
            </li>
            <li>
              <img src="../../assets/imges/phone1.png" alt="" /><span
                >手机号码:</span
              ><i>13129338939</i>
            </li>

            <li>
              <img src="../../assets/imges/qq.png" alt="" /> <span>QQ:</span
              ><i
                ><a
                  href="http://wpa.qq.com/msgrd?v=3&amp;uin=1025203743&amp;site=qq&amp;menu=yes"
                />1025203743</i
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="HeaderRight">
        <div>
          <img
            src="../../assets/imges/微信截图_20201208110934.png"
            title="微信公众号"
          />
        </div>
      </div>
    </div>
    <!-- <div style="flex:2;">
      
    </div> -->
    <!-- <div style="flex:2;padding-top:20px">
      <div class="router">
        <span style="color:#fff">

          <span style="margin-right:10px"><i style="font-style: unset;">您好,{{uname}}</i> <i class="i"
               style="font-style: unset;"
               @click="exit">退出</i></span>|
          <span style="margin-right:0.8rem">
            <router-link class="link"
                         to="/">首页</router-link>
          </span>|
          <router-link class="link"
                       to="/my"><span style="color:#f00"> 会员中心</span></router-link>|
          <router-link style="margin-right:10px"
                       to="/help"> 帮助中心</router-link>|

          <span style="margin-right:10px">服务热线: <i style="font-style:unset;color:#fff">0755-2308-0620</i> </span>|
          <span style="margin-right:10px"> QQ: <i style="font-style:unset;color:#fff;">574039568</i> </span>

        </span>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: 0,
      uname: "",
      User_Phone: "",
    };
  },
  created() {
    this.uname = window.sessionStorage.getItem('Name');
  },
  methods: {
    exit() {
      this.$confirm("尊敬的用户你确定要离开我了！！！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$router.push({ path: "/" });
          window.sessionStorage.clear();
          this.$message({
            type: "success",
            message: "再见!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "感谢你的留下！！",
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
// .active {
//   //background-image: url(../../assets/imges/26.png);
//   background-color: #a4cab6;
//   border: 1px solid #fff;
//   border-radius: 0.3rem;
//  // color: aquamarine;
// }
// img {
//   width: 10rem;
// }
.headerTop {
  height: 20rem;
  width: 100vh;
  overflow: hidden;
  //  头部最顶部样式
  .left {
    margin: 0;
    display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox; /* TWEENER - IE 10 */
    display: -webkit-flex; /* NEW - Chrome */
    display: flex;
    height: 3rem;
    width: 100%;
    background-color: #12a182;
    padding-right: 2rem;
    justify-content: flex-end;
    div {
      width: 40%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      div {
        flex: 1;
      }
      img {
        width: 2rem;
        //   position: relative;
        //   top: 0.5rem;
      }
    }
  }
  //  头部样式下靠左样式
  .headerCenetr {
    display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox; /* TWEENER - IE 10 */
    display: -webkit-flex; /* NEW - Chrome */
    display: flex;
    display: flex;
    .HeaderLetf {
      width: 70%;
      min-width: 600px;
      background: #fff;
      display: flex;
      display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
      display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
      display: -ms-flexbox; /* TWEENER - IE 10 */
      display: -webkit-flex; /* NEW - Chrome */
      display: flex;
      align-items: center;
      padding-top: 1rem;
      padding-bottom: 1rem;
      border: 0.1rem solid #ddd;
      div {
        padding-right: 1rem;
        ul li {
          height: 1.5rem;
          span {
            justify-content: center;
            width: 6rem;
          }
          i {
            color: #12a182;
          }

          img {
            width: 1rem;
          }
        }

        img {
          width: 10rem;
        }
      }
    }
    .HeaderRight {
      background-image: url(../../assets/imges/333.jpg);
      width: 100%;
      box-sizing: border-box;
      div {
        display: flex;
        display: -webkit-box; /* OLD - iOS 6-, Safari 3.1-6 */
        display: -moz-box; /* OLD - Firefox 19- (buggy but mostly works) */
        display: -ms-flexbox; /* TWEENER - IE 10 */
        display: -webkit-flex; /* NEW - Chrome */
        display: flex;
        justify-content: flex-end;
        i {
          position: relative;
          right: 6.5rem;
          top: 7rem;
        }
        img {
          padding: 1rem;
          width: 8rem;
          height: 8rem;
          min-width: 100px;
        }
      }
    }
  }

  //background-color: #2bae85;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/GlobalComponents/membersHeader.vue